import React from "react";
import { useDispatch, useSelector } from "react-redux";
import MultiSelectDropdown from "../../../../../components/multiSelectDropdown/multiSelectDropdown";
import { actionCreators } from "../redux/numberOfActiveMembersBySagas";

const CustomFilters = () => {
  const { filters = [], selectedFilters } = useSelector((state) => state.numberOfActiveMembersBy);
  const dispatch = useDispatch();

  const updateLocations = (data, param_name) => {
    dispatch(actionCreators.updateCategories({ data, param_name }));
  };

  return (
    <div>
      {filters.map(({ name, value, param_name }) => {
        let selected = selectedFilters.categories.filter((category) => category.name === name);
        return (
          <div className={"select-box-no-width"} key={name}>
            <p>{name}</p>
            <MultiSelectDropdown
              filterType={"Locations"}
              options={value.map((el) => {
                return {
                  name: el.name,
                  id: el.product_id || el.category_id,
                  selected: el.selected
                };
              })}
              // selectedFilters used only on first render and reset, then it on each change is empty array,
              // Component keep selected state because of the MultiSelectDropdown, which has its own inner state
              //for selectedFilters
              selectedFilters={selected[0]?.value.map((el) => {
                return {
                  name: el.name,
                  id: el.product_id || el.category_id,
                  selected: el.selected
                };
              })}
              enableDefaultSelected
              allSelectedPlaceholder={"All selected"}
              numberDisplayed={0}
              includeSelectAll={true}
              enableOnly={true}
              updateLocations={(data) => updateLocations(data, param_name)}
            />
          </div>
        );
      })}
    </div>
  );
};

export default CustomFilters;
